/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_RestInputs */

const en_workout_rest = /** @type {(inputs: Workout_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest`)
};

const pl_workout_rest = /** @type {(inputs: Workout_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przerwa`)
};

/**
* | output |
* | --- |
* | "Rest" |
*
* @param {Workout_RestInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const workout_rest = /** @type {((inputs?: Workout_RestInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_RestInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_workout_rest(inputs)
	return en_workout_rest(inputs)
});